/**
 * UK-time date formatting for UT game screens. Game times are stored in UTC;
 * Intl with Europe/London handles BST without the manual offset utilities.
 */
const TZ = 'Europe/London';

const part = (d: Date, opts: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat('en-GB', { timeZone: TZ, ...opts }).format(d);

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Wed 7 Oct" (always a 3-letter month; en-GB would give "Sept"). */
export function shortDate(iso: string | Date): string {
  const d = new Date(iso);
  const month = MONTHS[Number(part(d, { month: 'numeric' })) - 1];
  return `${part(d, { weekday: 'short' })} ${part(d, { day: 'numeric' })} ${month}`;
}

/** "21:00" */
export function kickOff(iso: string | Date): string {
  return part(new Date(iso), { hour: '2-digit', minute: '2-digit', hour12: false });
}

/** "Tue 6 Oct, 12:00" */
export function shortDateTime(iso: string | Date): string {
  return `${shortDate(iso)}, ${kickOff(iso)}`;
}

/** "Wednesday 7 October 2026" */
export function longDate(iso: string | Date): string {
  const d = new Date(iso);
  return `${part(d, { weekday: 'long' })} ${part(d, { day: 'numeric' })} ${part(d, { month: 'long' })} ${part(d, { year: 'numeric' })}`;
}

/** "£3.15" per player, from the pitch cost split between max players. */
export function perPlayerCost(pitchCost: number | null | undefined, maxPlayers: number | null | undefined): string | null {
  if (!pitchCost || !maxPlayers) return null;
  return `£${(pitchCost / maxPlayers).toFixed(2)}`;
}
